import { render, staticRenderFns } from "./DraftCampaigns.vue?vue&type=template&id=61fc853b"
import script from "./DraftCampaigns.vue?vue&type=script&lang=js"
export * from "./DraftCampaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports